import { useState, } from 'react';
export function useStateVar(initialState) {
    const [state, setState] = useState(initialState);
    return {
        get value() {
            return state;
        },
        set value(v) {
            setState(v);
        },
        set(v) {
            setState(v);
        },
    };
}
//# sourceMappingURL=useStateVar.js.map